import { DOCS_LANG_COOKIE, type DocsLangCode } from '@gitcenter/shared';

function readCookie(name: string): string | undefined {
    if (typeof document === 'undefined') return undefined;
    const m = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
    return m?.[1] ? decodeURIComponent(m[1]) : undefined;
}

export function setDocsLangCookie(lang: DocsLangCode): void {
    if (typeof document === 'undefined') return;
    document.cookie = `${DOCS_LANG_COOKIE}=${lang}; Path=/; Max-Age=31536000; SameSite=Lax`;
}

/** Cookie → Accept-Language → 默认 zh */
export function resolvePreferredDocsLang(): DocsLangCode {
    const c = readCookie(DOCS_LANG_COOKIE);
    if (c === 'en' || c === 'zh') return c;
    if (typeof navigator !== 'undefined' && /^en/i.test(navigator.language || '')) {
        return 'en';
    }
    return 'zh';
}
